export enum Path {
  WELCOME = 'welcome',
  LOGIN = 'login',
  FILES = 'files',
  PROFILES = 'profiles',
}
